import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useAppSelector } from "../../../../../../../hooks/store-hooks";
import { useListaCboService } from "../../../../../../../../use-cases/geo-veles/lista-cbo";
import { useCallback, useEffect, useState } from "react";
import { debounce } from "lodash";

export const CreateListaCboForm = () => {
  const { listaCbo } = useAppSelector((state) => state);
  const {
    createListaCbos,
    openCreateListaCboForm,
    setCreateListaCbosNome,
    selectedListaCboToEdit,
    setEditListaCboFields,
    openEditListaCboForm,
  } = useListaCboService();

  const [nomeLocal, setNomeLocal] = useState(
    listaCbo.createListaCboForm.fields.Nome
  );

  useEffect(() => {
    setNomeLocal(listaCbo.createListaCboForm.fields.Nome);
  }, [listaCbo.createListaCboForm.fields.Nome]);

  const debouncedUpdate = useCallback(
    debounce((value: string) => {
      setCreateListaCbosNome(value);
    }, 500),
    [setCreateListaCbosNome]
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setNomeLocal(value);
    debouncedUpdate(value);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={listaCbo.openCreateListaCbo}
      onClose={() => {
        openCreateListaCboForm(false);
      }}
    >
      <DialogTitle>Criar nova lista de CBOs</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Escolha um nome para a lista de CBOs
        </DialogContentText>
        <Box my={3}>
          <TextField
            error={Boolean(
              listaCbo.createListaCboForm.touched &&
                listaCbo.createListaCboForm.errors.find(
                  (item) => item.key === "Nome"
                )
            )}
            helperText={
              listaCbo.createListaCboForm.errors.find(
                (error) => error.key === "Nome"
              )?.message
            }
            value={nomeLocal}
            onChange={handleChange}
            autoFocus
            id="nome-lista-cbo"
            label="Digite o nome da lista de CBOs"
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => openCreateListaCboForm(false)}>Cancelar</Button>
        <Button
          onClick={async () => {
            setCreateListaCbosNome(nomeLocal);
            const novaLista = await createListaCbos();

            if (novaLista) {
              openCreateListaCboForm(false);
              setEditListaCboFields({ listaCbo: novaLista });
              openEditListaCboForm(novaLista); 
            }
          }}
        >
          Criar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
